import OrderDetail from '@app/components/order/OrderDetail';
import React from 'react';

const OrderDetailPage: React.FC = () => {
  return (
     <OrderDetail />
  )
};

export default OrderDetailPage;
